import React from 'react';
import {Trans} from 'react-i18next';
import i18next from 'i18next';
import Button from 'components/buttons/Button';
import Dialog, {DialogProps} from 'components/dialogs/Dialog';
import {DialogActions} from '@mui/material';

type Props = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   onClose?: () => void;
   maxWidth?: DialogProps['maxWidth'];
};

export const AlertDialog = (props: Props) => {
   const {open = true, content, title = 'Alert', onClose, maxWidth = 'sm'} = props;

   return (
      <Dialog open={open} close={onClose} maxWidth={maxWidth} header={title}>
         {content}

         <DialogActions sx={{mt: 2}}>
            <Button onClick={onClose} color="primary">
               <Trans>Close</Trans>
            </Button>
         </DialogActions>
      </Dialog>
   );
};
